import { cn } from "@core-ui/utils/cn";
import { useOverflowTooltip } from "ics-ui-kit/components/overflow-tooltip";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "ics-ui-kit/components/tooltip";

type Side = NonNullable<React.ComponentPropsWithoutRef<typeof TooltipContent>["side"]>;

type Align = NonNullable<React.ComponentPropsWithoutRef<typeof TooltipContent>["align"]>;

export type OverflowTooltipProps = {
	children: React.ReactNode;
	triggerTag?: React.ElementType;
	className?: string;
	tooltipClassName?: string;
	side?: Side;
	align?: Align;
	focus?: "high";
};

export const OverflowTooltip = ({
	children,
	className,
	focus,
	triggerTag,
	tooltipClassName,
	side,
	align,
}: OverflowTooltipProps) => {
	const { open, onOpenChange, ref } = useOverflowTooltip<HTMLDivElement>();
	const TriggerTag = triggerTag || "span";
	return (
		<TooltipProvider>
			<Tooltip onOpenChange={onOpenChange} open={open}>
				<TooltipTrigger asChild>
					<TriggerTag className={cn(className)} ref={ref}>
						{children}
					</TriggerTag>
				</TooltipTrigger>
				<TooltipContent align={align} className={cn("max-w-xs", tooltipClassName)} focus={focus} side={side}>
					{children}
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
};

OverflowTooltip.displayName = "OverflowTooltip";
